// extracted by mini-css-extract-plugin
export default {"timezoneSelectorContainer":"TimezoneSelector_timezoneSelectorContainer__teGWZ","label":"TimezoneSelector_label__S2BNO"};